import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Country Name',
    field: 'name',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Alpha 2 Code',
    field: 'alpha2Code',
    component: inputTextField({ req: false })
  }),
  createColumn({
    label: 'Alpha 3 Code',
    field: 'alpha3Code',
    component: inputTextField({ req: false })
  })
].concat(defaultColumns)
